import type { GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType } from './getTweets200PageAllOfThreeContentItemMediaLinksItemLinkType';
import type { GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfo } from './getTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfo';

/**
 * 링크 프리뷰 정보
 */
export type GetTweets200PageAllOfThreeContentItemMediaLinksItem = {
  /** 웹페이지 설명 */
  description?: string;
  /** 사이트 파비콘 URL */
  favicon?: string;
  /** 링크 유형 (외부 링크 또는 프로젝트 링크) */
  linkType?: GetTweets200PageAllOfThreeContentItemMediaLinksItemLinkType;
  /** 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크) */
  projectInfo?: GetTweets200PageAllOfThreeContentItemMediaLinksItemProjectInfo;
  /** 사이트 이름 */
  siteName?: string;
  /** 프리뷰 썸네일 URL */
  thumbnailUrl?: string;
  /** 웹페이지 제목 */
  title?: string;
  /** 원본 URL */
  url?: string;
};
